import { render, staticRenderFns } from "./build.vue?vue&type=template&id=400956a3&"
import script from "./build.vue?vue&type=script&lang=js&"
export * from "./build.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports